<template>
  <div>
    <Notification
      :content="notificationContent"
      :type="notificationStatus"
      :isNotificationOpen="isNotificationOpen"
      @notificationClosed="closeNotification"
    />
    <DatLayout>
      <DatTypeContainer slot="dat-type-container" />
    </DatLayout>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator';
import Notification from '@/components/common/Notification/Notification.vue';
import { INotification, store } from '@/store/modules/dats/types';
import DatLayout from './components/DatLayout/DatLayout.vue';
import DatTypeContainer from './components/DatVersions/DatTypeContainer.vue';

@Component({
  components: {
    DatLayout,
    DatTypeContainer,
    Notification
  }
})
export default class Dat extends Vue {
  @store.Getter
  private getNotification: INotification;

  private isNotificationOpen = false;

  private notificationContent = '';

  private notificationStatus = '';

  private closeNotification() {
    this.isNotificationOpen = false;
    this.notificationContent = '';
    this.notificationStatus = '';
  }

  @Watch('getNotification', {
    deep: true, immediate: true
  })
  private onNotificationChanged(newv: INotification | null) {
    if (newv) {
      this.isNotificationOpen = true;
      this.notificationStatus = newv.notificationStatus;
      const content = newv.content ? newv.content : '';
      this.notificationContent = content;
      if (newv.code === 200) {
        this.notificationContent = `${this.$t(content)}`;
      } else {
        this.notificationContent = `${this.$tc(content, newv.code, { field: newv.field })}`;
      }
    } else {
      this.closeNotification();
    }
  }
}
</script>
